<template>
  <div>
    <h1 class="above-menu">Company Profile</h1>
    <nav>
      <ul>
        <router-link tag="li" to="/company/profile">Profile</router-link>
        <router-link tag="li" to="/company/members">Agents</router-link>
        <router-link tag="li" to="/company/assistant">Assistant</router-link>
        <router-link tag="li" to="/company/customize">Customize</router-link>
        <router-link tag="li" to="/company/activate">Go Online</router-link>
      </ul>
    </nav>
  </div>
</template>

<script>
  import { tenantRoles } from '../utils/PfxUtils.js'
  import { mapGetters } from 'vuex'

  export default {
    name: 'TenantProfileMenu',
    data() {
      return {
        tenantRoles
      }
    },
    computed: {
      ...mapGetters([
        'subdomain',
        'role',
        'tenant',
        'tenantRole'
      ]),
    }
  }
</script>

<style lang="scss" scoped>
  @import '../pfx.scss';

  nav {
    margin-bottom: 1rem;
    border-bottom: 1px solid #eee;

    li {
      @include tablet-portrait-breakpoint {
        display: inline-block;
        min-width: 150px;
        text-align: center;
      }

      padding: 0.5rem 0;
      cursor: pointer;
      color: #b3b3b3;
    }
    li.router-link-active {
      color: #000;
      border-bottom: 2px solid $color-pfx-brand;
      font-weight: 600;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TenantProfileMenu.vue